const THEME_CACHE_KEY = "cachedThemeSettings";

export const defaultThemeSettings = {
    theme: "light",
    primaryColor: "#026094",
    greyColor: "#495057",
    textColor: "#878EA6",
    fontSize: "0.88rem",
    secondaryFontSize: "15px",
    fontFamily: "system-ui",
    borderRadius: "0.25rem",
    sidebarColor: "#e6f3fb",
    sidebarSecondaryColor: "#f5faff",
    sidebarSubmenuColor: "#003366",
    buttonSize: "35px",
    inputFieldHeight: "38px",  
    selectDropHeight: "35px",
    sidebarSizeLabel: "16px",
    headerTextSize: "0.88rem",
    headerHeight: "51px",
    headerColor: "#026094",
    svgSecondaryColor: "#495057",
    SecondaryLabelColor: '#026094',
    UserNameColor: '#FAFCFD',
    BreadcrumbColor: '#FAFCFD',
    DividerColor: '#FAFCFD',
    DividerWidth: '1px',
    tableHeight: '31px',
    BreadCrumbSlashColor: '#FAFCFD',
    sidebarBackGroundColor: '#fff',
    sidebarSelectedItemColor: '#495057',
    profileMenuColor: '#878EA6',
    profileMenuDropdown: '#fff',
    cardFontSize: "0.88rem",
    TableFontSize: '0.88rem',
    tableHeaderColor: '#878ea6',
    buttonsColor: '#026094',
    footerHeight: '68px',
    selectColor: '#878EA6',
    cardFooterBackground: '#fff',
    headerRowColor: '#fff',
    headerHeadColor: '#fafcfd',
    tableRowBgColor: 'e0f3ff',
    tableHoverTextColor: '#333538',
    sidebarHoverColor: '#f7f7f6',
    sidebarMenuHeight: '34px',
    sidebarPaddingRight: '30px',
    sidebarPaddingLeft: '11px',
    checkboxWidth: '20px',
    checkboxHeight: '20px',
    themeColor: '#f1f4f6',
    inputFieldColor:'#afb5ba',
    dropdownListColor:'#6c757d',
    iconColor:'#878EA6',
    sidebarWidth:'220px',
    sidebarCollapsedWidth:'100px',
    paginationSize:'13px',
    sidebarCollapsePaddingLeft:'0px',
    sidebarCollapsedLabelSize:'12px',
    sidebarCollapsedHeight:'34px',
    sidebarCollapsedTextSize:'15px',
    cardPaddingTop:'2.5rem',
    cardPaddingBottom:'2.5rem',
    cardRowGap: '1rem',
    gridRowGap: '4px'
};

const LEGACY_BUTTON_SIZES = {
    sm: "30px",
    md: "35px",
    lg: "39px",
    xl: '43px',
};

const LEGACY_SECONDARY_FONT_SIZES = {
    sm: "13px",
    md: "15px",
    lg: "17px",
};


const THEME_CSS_VARS = {
    primaryColor: "--primary-color",
    greyColor: "--grey-color",
    textColor: "--text-color",
    fontSize: "--font-size",
    secondaryFontSize: "--sidebar-font-size",
    fontFamily: "--font-family",
    borderRadius: "--border-radius",
    sidebarColor: "--sidebar-color",
    sidebarSecondaryColor: "--sidebar-secondary-color",
    sidebarSubmenuColor: "--blue-color",
    buttonSize: "--button-height",
    inputFieldHeight: "--input-field-height",
    selectDropHeight: "--select-drop-height",
    sidebarSizeLabel: "--sidebar-size-label",
    headerTextSize: "--header-text-size",
    headerHeight: "--header-height",
    headerColor: "--header-color",
    svgSecondaryColor: "--svg-secondary-color",
    SecondaryLabelColor: '--sidebar-label-color',
    UserNameColor: '--color-username',
    BreadcrumbColor: '--color-breadcrumb',
    BreadCrumbSlashColor: '--breadcrumb-slash-color',
    DividerColor: '--color-divider',
    DividerWidth: '--width-divider',
    tableHeight: '--height-table',
    sidebarBackGroundColor: '--sidebar-background-color',
    sidebarSelectedItemColor: '--sidebar-selected-menu-item',
    profileMenuColor: '--profile-menu-text-color',
    profileMenuDropdown: '--profile-menu-dropdown-color',
    TableFontSize: '--table-font-size',
    cardFontSize: '--card-font-size',
    tableHeaderColor: '--table-header-color',
    buttonsColor: '--buttons-color',
    footerHeight: '--card-footer-height',
    selectColor: '--select-color',
    cardFooterBackground: '--card-footer-color',
    headerHeadColor: '--table-header-head-color',
    headerRowColor: '--table-row-color',
    tableHoverTextColor: '--table-hover-text-color',
    tableRowBgColor: '--table-hover-bg',
    sidebarHoverColor: '--sidebar-hover-color',
    sidebarMenuHeight: '--sidebar-menu-item-height',
    sidebarPaddingLeft: '--sidebar-padding-left',
    sidebarPaddingRight: '--sidebar-padding-right',
    checkboxHeight: '--checkbox-height',
    checkboxWidth: '--checkbox-width',
    themeColor: '--app-theme-color',
    inputFieldColor:'--input-field-color',
    dropdownListColor:'--dropdown-list-color',
    iconColor:'--icon-color',
    sidebarWidth:'--sidebar-width',
    sidebarCollapsedWidth:'--sidebar-collapsed-width',
    paginationSize:'--pagination-font-size',
    sidebarCollapsePaddingLeft:'--sidebar-collapse-padding-left',
    sidebarCollapsedLabelSize:'--sidebar--collapsed-label-size',
    sidebarCollapsedTextSize:'--sidebar-collapsed-font-size',
    sidebarCollapsedHeight:'--sidebar-collapsed-menu-height',
    cardPaddingTop:'--card-padding-top',
    cardPaddingBottom:'--card-padding-bottom',
    cardRowGap: '--card-row-gap',
    gridRowGap: '--grid-row-gap'
};


export const normalizeThemeSettings = (settings) => ({
    ...settings,
    buttonSize:
        LEGACY_BUTTON_SIZES[settings.buttonSize] || settings.buttonSize,
    secondaryFontSize:
        LEGACY_SECONDARY_FONT_SIZES[settings.secondaryFontSize] ||
        settings.secondaryFontSize,
});

export const mapBackendThemeSettings = (apiData) => {
    const settings = {
        ...defaultThemeSettings,
    };

    if (Array.isArray(apiData)) {
        apiData.forEach((item) => {
            if (
                item?.theme_name &&
                item?.secondary_value !== undefined
            ) {
                settings[item.theme_name] = item.secondary_value;
            }
        });
    }

    return normalizeThemeSettings(settings);
};

export const applyThemeToRoot = (themeSettings) => {
    if (!themeSettings) {
        return;
    }

    const root = document.documentElement;
    const settings = normalizeThemeSettings(themeSettings);

    Object.entries(THEME_CSS_VARS).forEach(([key, cssVar]) => {
        const value = settings[key];

        if (value !== undefined && value !== null && value !== "") {
            root.style.setProperty(cssVar, value);
        }
    });
};

export const getCachedThemeSettings = () => {
    try {
        const raw = localStorage.getItem(THEME_CACHE_KEY);

        if (!raw) {
            return null;
        }

        return JSON.parse(raw);
    } catch (error) {
        console.error("Failed to read cached theme:", error);
        return null;
    }
};

export const setCachedThemeSettings = (themeSettings) => {
    try {
        localStorage.setItem(
            THEME_CACHE_KEY,
            JSON.stringify(themeSettings)
        );
    } catch (error) {
        console.error("Failed to cache theme:", error);
    }
};
